import type {GqlContext, GqlContextRecord} from "./types.js";

/**
 * Convert a GqlContext to a GqlContextRecord.
 */
export const toGqlContextRecord = ({
    fastlyCaching,
    curriculum,
    ...rest
}: GqlContext): GqlContextRecord => {
    const contextRecord: GqlContextRecord = {
        ...rest,
    };
    if (curriculum) {
        contextRecord.curriculum = curriculum;
    }
    if (fastlyCaching != null) {
        contextRecord.fastlyCaching = fastlyCaching as string;
    }
    return contextRecord;
};
